// Create ENUM for tree or list view
export const NoteView = {
  TREE: "tree",
  LIST: "list",
};
